export default __webpack_public_path__ + "f4fd968e149482d2a0b8fb2b810e95ca.png";